<template>
  <div class="basic">
    <div class="basic-header" id="exhall-list">
      <p>选择展会</p>
    </div>
    <div class="order-exhall">
      <div class="exhall-list">
        <template v-if="exList && exList.length > 0">
          <div class="list-one" v-for="(item, index) in exList" :key="index" @click="initData(item)"
            :class="exItem && exItem.id === item.id ? 'selected' : ''">
            {{ item.name }}
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          暂无数据！
        </div>
      </div>
    </div>
    <div class="basic-header" id="booth-box">
      <p>展位信息</p>
    </div>
    <div class="order-exhall">
      <div class="exhall-list">
        <template v-if="list && list.length > 0">
          <div class="list-one" v-for="(item, index) in list" :key="index" @click="selectHandle(item)"
            :class="selectItem.id === item.id ? 'selected' : ''" v-if="item.typeLanguage == '中文'">
            {{ item.name }}
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          暂无数据！
        </div>
      </div>
    </div>
    <div class="order-exhall">
      <div class="booth-box">
        <Row>
          <Col span="24" v-if="rowInfo">
          <div class="item" :class="selectInfo && selectInfo.id === rowInfo.id ? 'select' : ''" @click="rowClick">
            <h4>{{ rowInfo.pjName }}</h4>
            <div class="txt1">
              价格:{{ rowInfo.price }} {{ rowInfo.pType }} / {{ rowInfo.cunit }}
            </div>
            <div class="line u-req">
              <span>面积 : </span>
              <InputNumber :precision="0" :max="999999999" :min="1" v-model="rowCount"></InputNumber>
              <span class="unit">㎡</span>
            </div>
          </div>
          </Col>
          <Col span="24" v-if="standInfo.length">
          <div class="item" :class="checkList.length ? 'select' : ''">
            <h4>标准展位</h4>
            <div class="txt2">
              <el-checkbox-group v-model="checkList">
                <template v-for="item in standInfo">
                  <el-checkbox :label="item" @click.native="standClick">{{ item.pjName }} {{ item.price }} {{
                    item.pType }} / {{ item.cunit }}</el-checkbox><br />
                  <div class="line u-req" style="margin-top:10px;margin-left: 15px;">
                    <span>数量 : </span>
                    <InputNumber :precision="0" :step="1" :max="999" :min="0" v-model="item.myCount"
                      @on-change="changeTotalNum"></InputNumber>
                    <span class="unit">个</span>
                  </div><br />
                </template>
              </el-checkbox-group>
            </div>
            <div class="tip">（4个展位以下，每家企业最多只能申请1个角位）</div>
          </div>
          </Col>
        </Row>
      </div>
      <div class="total">
        合计: <span>{{ totalNum }}</span>元
      </div>

      <div class="info">
        <div class="info-title">填写备注说明:</div>
        <ul>
          <li>
            特装展位：原则36平米以上起租，不包含其它任何物件，参展商须自行寻找展位搭建商
          </li>
          <li>
            标准展位：标准展位为大会统一搭建，展位规格为3m x
            3m，包括两盏射灯、一个220V/5A电源插座、一张咨询桌、两把折椅、满铺地毯。
          </li>
          <li>展位分配将依照“先到先得”的原则，按照预定面积大小、付款顺序先后进行分配</li>
          <li>组委会禁止两个或多个公司合租一个标准展位，严禁转卖展位</li>
          <li>参展方需对自己企业及参展产品的合法性负责。非本行业企业谢绝参展</li>
          <li>最终解释权归组委会所有</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "order",
  data () {
    return {
      checkList: [],

      taskList: [],
      lastInfo: null, // 上次提交的信息
      loading: false,
      list: [],
      boothList: [],
      chooseBooth: null,
      otherList: [], // 线上增值服务
      otherList2: [], // 线下增值服务
      otherList3: [],
      chooseOtherArr: [], // 选中的增值服务
      isAllChoose: [], // 是否全选
      orderInfo: null,
      isChange: false,
      middleInfo: null,
      otherTotalPrice: 0,
      onlineFile: null,
      offlineFile: null,
      ChooseCheck: false,
      join: false, //是否参加过
      fixedId: 0,
      gudingprice: 0,
      remark: "",
      selectType: "光地",
      IsNeedActivity: "0",
      input1: 0,
      radio: "",

      selectItem: null, // 选中的展区
      selectInfo: null, // 选中的展位类型
      rowInfo: null, // 特装
      rowCount: 0,
      standInfo: [], // 标展
      standSelect: null, // 标展
      standIdArr: [], // 标展
      standCount: 0,
      total: 0,
      exItem: null, // 选中的展会
      exList: [],
      exhibitionId: '',
      totalNum: 0,
    };
  },
  watch: {
    rowInfo (val, oldVal) {
      this.changeTotalNum();
    },
    checkList (val, oldVal) {
      this.changeTotalNum();
    },
    rowCount (val, oldVal) {
      this.changeTotalNum();
    },
  },
  computed: {
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId () {
      return this.$route.query.groupId;
    },
    totalNum () {
      // 合计总价
      let num = 0;
      if (!this.selectInfo) return 0;
      if (this.selectInfo.boothType === "光地") {
        if (!this.rowCount) return 0;
        num =
          (this.rowCount / Number(this.selectInfo.standstall)) * this.selectInfo.price;
      } else {
        if (!this.standCount) return 0;
        num = this.standCount * this.selectInfo.price;
      }
      num = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
      this.total = num;
      return num;
    },
  },
  created () {
    this.getExList();
  },
  methods: {
    ...mapActions({
      getApplyExhibition: "commonFill/getApplyExhibition",
      getApplyFlow: "commonFill/getApplyFlow",
      getApplyFlowSpeed: "commonFill/getApplyFlowSpeed",
      getDePjNameGroup: "commonFill/getDePjNameGroup",
      addApplyOrder: "commonFill/addApplyOrder",
      getOrderDetail: "commonFill/getOrderDetail",
      editApplyOrder: "commonFill/editApplyOrder",
      getDeTerm: "commonFill/getDeTerm",
      getGroupInfoById: "commonFill/getGroupInfoById",
      getFile: "commonFill/getFile",
      getjoin: "commonFill/getjoin",
    }),
    changeTotalNum () {
      let num = 0;
      if (this.selectInfo && this.selectInfo.boothType === '光地') {
        if (!this.rowCount) {
          this.totalNum = 0;
          return
        };
        num = this.rowCount / Number(this.selectInfo.standstall) * this.selectInfo.price;
      } else {
        if (!this.checkList.length) {
          this.totalNum = 0;
          return 0;
        } else {
          this.checkList.forEach(c => {
            num += (c.myCount * c.price);
          });
        }
      }
      num = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
      this.totalNum = num;
    },
    async getExList () {
      let elist = await this.getApplyExhibition();
      this.exList = elist;
      if (elist && elist[0]) {
        this.exhibitionId = elist[0].id;
        console.log('exList', this.exList);
        this.initData(elist[0])
      }
    },
    async initData (exInfo) {
      this.exItem = exInfo;
      this.$emit('changeExhibtion', exInfo);
      this.standCount = 0;
      this.rowCount = 0;
      this.selectItem = null;
      this.selectInfo = null;
      this.rowInfo = null;
      this.standInfo = [];
      this.standIdArr = [];
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      console.log("getApplyFlowSpeed", info); // 上一次提交的信息

      if (info && info.info) {
        this.lastInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map((c) => {
            if (this.lastInfo && this.lastInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }
      // 展位、增值服务
      let list = await this.getDePjNameGroup({
        IsBoothGroup: "是",
        ExhibitionId: exInfo.id,
        TypeLanguage: "中文",
      }); // 是：展区选择展位； 否：增值服务项目
      if (list && list.length) {
        this.selectItem = list[0];
        this.selectHandle(list[0]);
      }
      this.list = list;
    },
    async validHandle () {
      if (!this.exItem) {
        this.$Message.warning("请选择您要参展的展会");
        this.scorllHandle('exhall-list');
        return Promise.resolve({ valid: false });
      }
      if (!this.selectItem) {
        this.$Message.warning("请选择您要参展的展区");
        this.scorllHandle('booth-box');
        return Promise.resolve({ valid: false });
      }
      if (!this.selectInfo && !this.checkList.length) {
        this.$Message.warning("请选择展位信息");
        this.scorllHandle('booth-box');
        return Promise.resolve({ valid: false });
      }
      if (this.selectInfo && this.selectInfo.boothType === '光地') {
        let minCount = this.selectInfo.minCount * Number(this.selectInfo.standstall);
        if (this.rowCount < minCount) {
          this.$Message.warning(`展位面积应大于${minCount}`);
          this.scorllHandle('booth-box');
          return Promise.resolve({ valid: false });
        }
      } else {
        let allCount = 0; // 标展总个数
        let milCount = 0; // 角位个数
        this.checkList.forEach(c => {
          allCount += c.myCount;
          if (c.pjName.indexOf('非角位') === -1) { // 判断是否是角位
            milCount += c.myCount;
          }
        });
        if (!allCount) {
          this.$Message.warning(`请输入展位数量`);
          this.scorllHandle('booth-box');
          return Promise.resolve({ valid: false });
        }
        // 每家企业最多申请两个角位 / Each enterprise can apply for up to two corner booths  
        if (milCount > 2) {
          this.$Message.warning(`每家企业最多申请两个角位`);
          this.scorllHandle('booth-box');
          return Promise.resolve({ valid: false });
        }
        // 4个展位以下，每家企业最多只能申请1个角位 / Within 4 booths, each enterprise can only apply for a maximum of 1 corner booth
        if (allCount <= 3 && milCount > 1) {
          this.$Message.warning(`4个展位以下，每家企业最多只能申请1个角位`);
          this.scorllHandle('booth-box');
          return Promise.resolve({ valid: false });
        }
      }
      // 上面为选择逻辑判断
      let orderList = []
      if (this.selectInfo) { // 特装
        console.log('this.selectInfo', this.selectInfo);
        let total = this.rowCount / Number(this.selectInfo.standstall) * this.selectInfo.price;
        total = Number(total.toString().match(/^\d+(?:\.\d{0,2})?/));
        let Area = this.rowCount;
        orderList.push({
          ApplyCompanyOrderId: this.applyCompanyOrderId,
          DePjNameGroupId: this.selectItem.id,
          DePjNameGroupName: this.selectItem.name,
          Name: this.selectInfo.pjName,
          Area: Area,
          Unit: this.selectInfo.cunit,
          UnitPrice: this.selectInfo.price,
          TotalPrice: total,
          MonetaryUnit: this.selectInfo.pType,
          IsAgent: "否",
          RexMoney: total,
          GpName: this.selectInfo.gpName || "",
          GpCode: this.selectInfo.gpCode || "",
          PjCode: this.selectInfo.pjCode || "",
          GroupId: this.selectInfo.groupId || "",
          PjFormat: this.selectInfo.pjFormat || "",
          BoothType: this.selectInfo.boothType || "",
        })
      } else { // 标展
        console.log('this.checkList', this.checkList);
        this.checkList.forEach(c => {
          let Area = c.myCount;
          Area = Number(c.standstall) * c.myCount;
          let total = c.myCount * c.price;
          total = Number(total.toString().match(/^\d+(?:\.\d{0,2})?/));
          orderList.push({
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.selectItem.id,
            DePjNameGroupName: this.selectItem.name,
            Name: c.pjName,
            Area: Area,
            Unit: c.cunit,
            UnitPrice: c.price,
            TotalPrice: total,
            MonetaryUnit: c.pType,
            IsAgent: "否",
            RexMoney: total,
            GpName: c.gpName || "",
            GpCode: c.gpCode || "",
            PjCode: c.pjCode || "",
            GroupId: c.groupId || "",
            PjFormat: c.pjFormat || "",
            BoothType: c.boothType || "",
          })
        });
      }
      return Promise.resolve({ valid: true, req: orderList });
    },
    scorllHandle (id) {
      document.getElementById(id).scrollIntoView();
    },
    selectHandle (e) {
      if (!e) return;
      if (this.checkList) {
        this.checkList.map(c => {
          c.myCount = 0;
        });
      }
      this.totalNum = 0;
      this.checkList = [];
      this.rowCount = 0;
      this.selectItem = e;
      this.selectInfo = null;
      this.rowInfo = null;
      this.standInfo = [];
      this.standIdArr = [];
      console.log("selectItem", e);
      if (!e.dePjNameList.length) return;
      e.dePjNameList.forEach((c) => {
        if (c.boothType === "光地") {
          this.rowInfo = c;
        } else {
          c.myCount = 0;
          this.standInfo.push(c);
          this.standIdArr.push(c.id);
        }
      });
      console.log("rowInfo", this.rowInfo);
      console.log("standInfo", this.standInfo);
    },
    confirm () {
      this.isChange = false;
      this.selectItem = this.middleInfo;
      if (this.middleInfo.dePjNameList.length > 0) {
        this.middleInfo.dePjNameList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
      }
      this.boothList = this.middleInfo.dePjNameList;
      this.chooseBooth = null;
    }, 
    ItemChange () {
      if (this.standSelect) return;
      this.selectInfo = this.standInfo[0];
      this.standSelect = this.standInfo[0];
      this.rowCount = 0;
    },
    standClick () {
      this.selectInfo = null;
      this.rowCount = 0;
    },
    rowClick () {
      this.checkList.map(c => {
        c.myCount = 0;
      });
      this.totalNum = 0;
      this.checkList = []
      this.selectInfo = this.rowInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.basic {
  overflow: hidden;

  &-header {
    width: 100%;
    height: 48px;
    background-color: #f2f2f2;
    padding: 0 20px;
    color: #353535;

    p {
      line-height: 48px;
      font-size: 15px;
    }

    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
}

.order {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: rgba(0, 161, 233, 1);

      .box {
        div {
          background-color: rgba(0, 161, 233, 1);
        }
      }
    }

    .finished {
      color: rgba(0, 161, 233, 1);

      .box {
        background-color: rgba(0, 161, 233, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: rgba(0, 161, 233, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-exhall {
    padding: 10px;
    background-color: #fff;

    .exhall-header {
      width: 100%;
      height: 46px;
      background-color: #e6eef7;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .exhall-list {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 0 0px;
      background-color: #fff;

      .list-one {
        padding: 4px 20px;
        border: solid 1px #e3e3e3;
        margin: 0 15px 15px 0;
        border-radius: 5px;
        cursor: pointer;
      }

      .selected {
        background-color: #00a1e9;
        border: solid 1px #00a1e9;
        color: #fff;
      }
    }

    .booth-list {
      background-color: #fff;
      margin-bottom: 30px;
      overflow: hidden;

      &-top {
        margin-top: 40px;
        width: 100%;
        line-height: 64px;
        text-align: center;
        font-size: 20px;
        color: #666;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;

        .top-item {
          height: 64px;
          border-radius: 10px 10px 0px 0px;
          background-color: #f7f7f7;
          width: calc(50% - 10px);
          cursor: pointer;

          &.active {
            color: #fff;
            background-color: rgba(0, 161, 233, 1);
          }
        }
      }

      &-content {
        border: solid 1px rgba(0, 161, 233, 1);
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      &-bottom {
        width: 100%;
        position: relative;
        border: solid 1px rgba(0, 161, 233, 1);
        border-top-color: transparent;
        border-radius: 0px 0px 10px 10px;
        background-color: #f7f7f7;
        padding: 20px;

        .bottom-select {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
        }

        .bottom-txt {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }

  &-other {
    background-color: #fff;
    padding: 0 30px 30px;

    .other-header {
      width: 100%;
      height: 46px;
      background-color: #e6eef7;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .other-online {
      padding: 0 30px;
      margin-bottom: 30px;
      font-size: 16px;

      a {
        text-decoration: underline;
      }
    }

    .other-list {
      width: 1080px;
      margin: 0 auto 30px;
      border: solid 1px #e5e5e5;

      .top {
        background-color: #f5f5f5;
        height: 46px;
        line-height: 46px;
        position: relative;
        padding: 0 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        border-bottom: 1px solid #e5e5e5;

        .r {
          cursor: pointer;
          display: flex;
          align-items: center;

          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }

      .content {
        padding: 20px 20px 0 20px;

        .content-one {
          width: 100%;
          margin: 0 auto 20px;
          border: 1px solid #e5e5e5;

          .title {
            width: 100%;
            height: 46px;
            background-color: #f5f5f5;
            line-height: 46px;
            font-size: 16px;
            color: #333;
            padding-left: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .details {
            width: 100%;
            height: 230px;
            display: flex;

            .text {
              width: 50%;
              height: 100%;
              padding: 0 30px;
              position: relative;
              cursor: pointer;
              color: #333;
              font-size: 16px;

              .time {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                span {
                  width: 100px;
                }
              }

              .choose {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 0;
                height: 0;
                border-bottom: 46px solid #d9d9d9;
                border-left: 46px solid transparent;

                i {
                  position: absolute;
                  top: 10px;
                  left: -30px;
                  color: #fff;
                  font-size: 30px;
                }
              }

              .choosed {
                border-bottom: 46px solid #00a1e9;
              }
            }

            img {
              width: 50%;
              height: 100%;
            }
          }
        }
      }
    }

    .total {
      width: 100%;
      min-height: 173px;
      background-color: #f5f5f5;
      border: solid 1px #e5e5e5;
      text-align: right;
      font-size: 16px;
      color: #333;
      padding: 30px;

      p {
        line-height: 1;
      }

      .red {
        color: #00a1e9;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    padding-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: rgba(0, 161, 233, 1);
      font-size: 16px;
      border-color: rgba(0, 161, 233, 1);
    }
  }
}

.change-modal {
  padding: 6px 16px 8px;

  &-top {
    display: flex;
    align-items: center;

    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }

  &-bottom {
    margin-left: 40px;
  }

  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}

.table {
  display: table;
  margin: 5px;

  .row {
    display: table-row;
  }

  .cell {
    display: table-cell;
    padding: 5px;

    &.f-tal {
      width: 100px;
    }
  }
}

.booth-box {
  .item {
    background-color: #f5f5f5;
    margin-bottom: 20px;
    padding: 15px;
    position: relative;
    cursor: pointer;
    border-radius: 4px;

    &::after {
      content: "未选择";
      background-color: rgb(151, 151, 151);
      color: #fff;
      font-size: 18px;
      line-height: 2.5;
      padding: 0 20px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
      border-bottom-left-radius: 10px;
      border-top-right-radius: 4px;
    }

    &.select {
      background-color: #d7ecf6;

      &::after {
        content: "已选择";
        background-color: #00a1e9;
      }
    }

    h4 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 20px;
      color: #333;
      font-weight: normal;
      margin-bottom: 20px;
    }

    .txt1 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
      height: 52px;
    }

    .line {
      font-size: 14px;
      margin-bottom: 10px;

      .unit {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .tip {
      line-height: 1;
      font-size: 12px;
      color: rgb(128, 128, 128);
      margin-top: 6px;
    }
  }
}

.u-req {
  display: inline-block;

  &::before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}

.total {
  background-color: #f5f5f5;
  line-height: 46px;
  padding: 0 20px;
  text-align: right;
  font-size: 16px;

  span {
    color: #ed4014;
    font-size: 20px;
    font-weight: 600;
  }
}

.info {
  padding: 20px 0;

  &-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  li {
    margin-left: 2em;
    line-height: 1.8;
    list-style-type: disc;
  }
}

.info-side {
  position: fixed;
  top: 200px;
  left: 0;
  z-index: 99999999;
  background-color: #fff;
  width: 200px;
}
</style>
